import React, { useEffect } from 'react';
import { Box, Container, Link, Typography } from '@medely/web-components';
import config from 'config';
import SignUpForm from './SignUpForm';
import { useSignUpEvent } from '@mp';

const SignUp = (): React.ReactElement => {
  const { trackSignUpView } = useSignUpEvent();

  useEffect(trackSignUpView, []);

  return (
    <Box mt={5} mb={5}>
      <Box mb={3}>
        <Typography variant="h4" align="center">
          Create Your Account
        </Typography>
        <Typography mt={3} variant="body1" align="center" color="textSecondary">
          Earn more and book per diem jobs or assignments on your schedule.
        </Typography>
      </Box>
      <Container maxWidth="sm">
        <Box px={4}>
          <SignUpForm />
          <Box mt={2}>
            <Typography display="block" variant="caption" color="textSecondary">
              By proceeding, I agree to Medely&apos;s{' '}
              <Link external href={config.professionalTermsPathname}>
                Terms of Use
              </Link>{' '}
              and acknowledge that I have read the{' '}
              <Link external href="https://medely.com/privacy-policy">
                Privacy Notice
              </Link>
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default SignUp;
